// Styles for ControlModeItem component
export const listItemStyles = {
  py: 2,
  px: 3,
  borderRadius: 1,
  bgcolor: 'rgba(0, 0, 0, 0.1)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  mb: 2,
  width: '100%',
};

export const accordionStyles = {
  width: '100%',
  mt: 2,
  mb: 2,
  bgcolor: 'rgba(0, 0, 0, 0.01)',
  boxShadow: 'none',
  border: 'none',
  borderRadius: 1,

  '&:first-of-type': {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  '&:last-of-type': {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
};

export const accordionSummaryStyles = {
  bgcolor: 'rgba(0, 0, 0, 0.05)',
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  '&:hover': {
    bgcolor: 'rgba(0, 0, 0, 0.08)',
  },
  minHeight: 64,
  transition: 'background-color 0.2s',
};

export const accordionDetailsStyles = {
  p: 3,
};

export const textFieldStyles = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
  },
};

export const errorTextStyles = {
  mt: 1,
  color: 'error.main',
  fontWeight: 'medium',
};
